<template>

  <div v-if="!$apollo.loading" class="mt-20 ms-2 me-2">

      <div v-if="player.length > 0" class="w-full flex-col flex-wrap justify-around items-center">

        <div v-if="showMap" class="flex flex-col  w-screen h-screen justify-center items-center">

          <div class="w-full flex justify-center">

                <button class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded
                shadow hover:shadow-lg outline-none focus:outline-none me-1 mb-1" type="button" style="transition: all .15s ease"
                  v-on:click="closeMap">
                {{$t('profile.close')}}
                </button>
          </div>

          <div class="flex justify-center items-center">
            
            <my-google-maps-view :location="selectedLocation"/>
          </div>
        </div>

        <div v-else>

          <div v-if="!displayGroup && selectedGroup == null" class="mt-5 lg:mt-10">

            <div v-if="!showCreateGroup">

            <div class="w-full flex justify-center">

                <button class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded
                shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1" type="button" style="transition: all .15s ease"
                  v-on:click="showCreateGroup = !showCreateGroup">
                {{$t('player.createGroup')}}
                </button>
              </div>

                <div class="w-full flex justify-center">
                      
                      <adding-group class="mt-4 lg:mt-8" :playerId="player[0].id" :userId="user.id" :reload="myReload"></adding-group>
                </div>
            </div>


            <div v-else>

              <div >
                <button class="bg-pink-500 text-white active:bg-pink-600 font-bold uppercase text-sm px-6 py-3 rounded
                shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1" type="button" style="transition: all .15s ease"
                  v-on:click="showCreateGroup = !showCreateGroup">
                {{$t('profile.close')}}
                </button>
              </div>
                  
              <create-group class="mt-4 lg:mt-8" :playerId="player[0].id" :userId="user.id" 
              :email="email" :myReload="myReload" :playerName="player[0].nickname"/>
            </div>
          </div>

          <div class="bg-purple100" v-if="displayGroup && selectedGroup != null">
                        
              <button  class=" mt-10 mb-10 text-center rounded-lg p-5 bg-red-400"
              @click="closeGroup">{{$t('profile.close')}}</button>

              <players-group-info :playerId="player[0].id" :groupInfo="selectedGroup" :openMap="openMap" :player="player[0]"
              :reload="myReload"/>
          </div>

          <div v-else v-for="(group, i ) in playersGroups" :key="i">

              <players-group-card :playersGroup="group" :showGroupMethod="showGroupMethod"/>
          </div>
        </div>
        
        <div class="myFixedPaddingHeight">

        </div>
    </div>

    <div v-else>

          <label><strong>{{$t('player.createPlayer')}}</strong></label>
    </div>
  </div>

  <div v-else>

    <ring-loader ></ring-loader> 
  </div>
</template>

<script>

import createGroup from '../components-two/CreateGroup';

import myGoogleMapsView from '../components/MyGoogleMapsView';


import addingGroup from '../components-two/AddingGroup'
import PlayersGroupInfo from '../components-two/PlayersGroupInfo'
import PlayersGroupCard from '../components-two/PlayersGroupCard'
import myQueries from '../hasura/myQueries';

import twoMyQueries from '../hasura/myTwoQueries';

// import myInserts from '../hasura/twoMyInserts';
// import myDeletes from '../hasura/twoMyDeletes';

// import twoMyQueries from '../hasura/twoMyQueries';

// import myInserts from '../hasura/twoMyInserts';
import myDeletes from '../hasura/myTwoDeletes';

import componentsHelpers from '../classes/componentHelpers';

import moment from 'moment';

import { RingLoader } from 'vue-spinners-css';

export default {

  mounted(){
    
    // localStorage.setItem('clientLayout3', 'playersGroups');

    this.$layoutType = 0;
    // console.log(`inside playersgroups`);
  },

  components:{

    createGroup,
    addingGroup,
    PlayersGroupCard,
    PlayersGroupInfo,
    RingLoader,
    myGoogleMapsView
    
  },

  methods:{

    openMap(location){

      this.selectedLocation = location;
      
      this.showMap = true;
    },

    closeMap(){

      this.showMap = false;

      this.selectedLocation = null;
    },

    myReload(){

            //  console.log(`in reload`);
            location.reload();
    },

    showGroupMethod(group){

      this.displayGroup = true;
      this.selectedGroup = group;
    },

    closeGroup(){
      
      this.displayGroup = false;
      this.selectedGroup = null;
    }
  },

  apollo:{

    playerAndUser:{
         
      query: twoMyQueries.player_and_user_query,

      variables(){
                    
        return{
        
            userId: this.$userId
        }
      },

      update(data){


        // console.log(`data.two_player: ${JSON.stringify(data.two_player)}`);

        // console.log(`data.two_player: ${JSON.stringify(data.two_player[0])}`);

        // console.log(`data.two_player.user: ${JSON.stringify(data.two_player[0].user)}`);


        if(data.two_player.length> 0)
        {

          this.player = data.two_player;

          this.user = data.two_player[0].user;

          // console.log(`this.user: ${JSON.stringify(this.user[0])}`)

          // console.log(`this.user.id: ${this.user[0].id}`)

          if(this.user.length > 0){

            this.email = this.user[0].email;
          }
        }
      },

      error(error){
        
        if(this.playerInfoError == ''){
          
          componentsHelpers.sendError(this.$apollo, this.userId,'PlayersGroups', 'apollo', 'brand', error);

          componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

          this.playerInfoError = JSON.stringify(error);
        }
      },

      skip(){

        return JSON.stringify(this.$userId) == '{}';
      }
    },

    playersGroups:{
        
      query: twoMyQueries.players_groups_query,

      variables(){

            return{

                nowDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
                playerId: this.player[0].id
            }
        },

      update(data){

        // console.log(`players_groups_query: ${JSON.stringify(data)}`);

        this.playersGroups = data.two_play_group;

        // console.log(`playersGroups: ${JSON.stringify(this.playersGroups)}`);

        return data.two_play_group
      },

      error(error){
        
        if(this.groupsError == ''){

          componentsHelpers.sendError(this.$apollo, this.userId,'PlayersGroups', 'apollo', 'playersGroups', error);

          componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

          this.groupsError = JSON.stringify(error);
        }
      },
      skip(){

        return this.player.length < 1;
      }
    },
  },

  data(){

    return{

      playersGroups:[],
      user: null,
      player:[],
      displayGroup: false,
      selectedGroup: null,
      email: '',
      showCreateGroup: false,
      playerInfoError: '',
      groupsError:'',
      selectedLocation: null,
      showMap: false,
    }
  }

}
</script>

<style>

</style>